import axios from 'axios';

export function request(path, method = 'GET', content = {}, pending = false, pendingMessage = 'Loading...') {

    // return fetch(process.env.REACT_APP_INFRA_BACK_ENDPOINT + path, {
    //     method: method,
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify(content),
    // });
    return axios({
        method,
        url: process.env.REACT_APP_INFRA_BACK_ENDPOINT + path,
        data: JSON.stringify(content),
        headers: { 'Content-Type': 'application/json' }
    });
}


export function get(path, pending = false, pendingMessage = 'Loading...') {
    return request(path, 'GET', {}, pending, pendingMessage);
}


export function post(path, content = {}, pending = false, pendingMessage = 'Loading...') {
    return request(path, 'POST', content, pending, pendingMessage);

}


